"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductionStage = exports.StagingStage = exports.DevelopmentStage = exports.AuthEventType = void 0;
exports.AuthEventType = {
    ACCOUNT_CHANGED: 'auth.accountChanged',
    USER_SIGNED_IN: 'auth.userSignedIn',
    USER_SIGNED_OUT: 'auth.userSignedOut',
};
exports.DevelopmentStage = {
    clientId: '9c5e7e27-eac9-4a13-a41d-80110b31fdfe',
    signinAuthority: 'https://apetitoadb2cdevelopment.b2clogin.com/apetitoadb2cdevelopment.onmicrosoft.com/B2C_1_adb2cdevelopmentsignupandin',
    signupAuthority: 'https://apetitoadb2cdevelopment.b2clogin.com/apetitoadb2cdevelopment.onmicrosoft.com/B2C_1_adb2cdevelopmentsignup',
    impersonationAuthority: 'https://apetitoadb2cdevelopment.b2clogin.com/apetitoadb2cdevelopment.onmicrosoft.com/B2C_1A_IMPERSONATION',
    changePasswordAuthority: 'https://apetitoadb2cdevelopment.b2clogin.com/apetitoadb2cdevelopment.onmicrosoft.com/B2C_1_adb2cdevelopmentpassword',
    knownAuthorities: ['apetitoadb2cdevelopment.b2clogin.com'],
    scopes: ['openid', 'https://apetitoadb2cdevelopment.onmicrosoft.com/meinapetito/portal-api/All'],
    navigateToLoginRequestUrl: true,
    editProfileAuthority: 'https://apetitoadb2cdevelopment.b2clogin.com/apetitoadb2cdevelopment.onmicrosoft.com/B2C_1_adb2cdevelopmentedit',
};
exports.StagingStage = {
    clientId: 'd042e22a-9932-4796-93be-14a15c1e70a7',
    signinAuthority: 'https://apetitoadb2cstaging.b2clogin.com/apetitoadb2cstaging.onmicrosoft.com/B2C_1_adb2cstagingsignupandin',
    signupAuthority: 'https://apetitoadb2cstaging.b2clogin.com/apetitoadb2cstaging.onmicrosoft.com/B2C_1_adb2cstagingsignup',
    impersonationAuthority: 'https://apetitoadb2cstaging.b2clogin.com/apetitoadb2cstaging.onmicrosoft.com/B2C_1A_IMPERSONATION',
    changePasswordAuthority: 'https://apetitoadb2cstaging.b2clogin.com/apetitoadb2cstaging.onmicrosoft.com/B2C_1_adb2cstagingpassword',
    knownAuthorities: ['apetitoadb2cstaging.b2clogin.com'],
    scopes: ['openid', 'https://apetitoadb2cstaging.onmicrosoft.com/meinapetito/portal-api/All'],
    navigateToLoginRequestUrl: true,
    editProfileAuthority: 'https://apetitoadb2cstaging.b2clogin.com/apetitoadb2cstaging.onmicrosoft.com/B2C_1_adb2cstagingedit',
};
exports.ProductionStage = {
    clientId: '5ad71154-0191-4f0d-a3dd-903c8d2953a2',
    signinAuthority: 'https://apetitoadb2c.b2clogin.com/apetitoadb2c.onmicrosoft.com/B2C_1_adb2csignupandin',
    signupAuthority: 'https://apetitoadb2c.b2clogin.com/apetitoadb2c.onmicrosoft.com/B2C_1_adb2csignup',
    impersonationAuthority: 'https://apetitoadb2c.b2clogin.com/apetitoadb2c.onmicrosoft.com/B2C_1A_IMPERSONATION',
    changePasswordAuthority: 'https://apetitoadb2c.b2clogin.com/apetitoadb2c.onmicrosoft.com/B2C_1_adb2cpassword',
    knownAuthorities: ['apetitoadb2c.b2clogin.com'],
    scopes: ['openid', 'https://apetitoadb2c.onmicrosoft.com/meinapetito/portal-api/All'],
    navigateToLoginRequestUrl: true,
    editProfileAuthority: 'https://apetitoadb2c.b2clogin.com/apetitoadb2c.onmicrosoft.com/B2C_1_adb2cediting',
};
